export class PriorCourseUnit {
    public externalUnitId: string;
    public unitId: string;
    public unitCode: string;
    public unitTitle: string;
    public yearCompleted: number;
    public supportingDocuments: any[];
    public supportingLinks: string[];
    public hasQueuedAttachments: boolean;
    public institution: any;
    public institutionCode: string;
    public institutionName: string;
    public display: string;
    public matchedUnitTitle: string;
    public matchedUnitCode: string;
    public monashUnitCode: string;
    public creditOrPreclusion: string;


}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/model/PriorCourseUnit.ts